import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from '@modules/error/error.component';
import { InitComponent } from '@modules/init/init.component';
import { ProcessComponent } from '@modules/process/process.component';
import { WebauthPopupComponent } from '@modules/webauth-popup/webauth-popup.component';
import { WebauthRedirectComponent } from '@modules/webauth-redirect/webauth-redirect.component';

const routes: Routes = [
  {
    path: 'init/:userId',
    component: InitComponent,
    pathMatch: 'full',
  },
  {
    path: 'process',
    component: ProcessComponent,
    pathMatch: 'full',
  },
  {
    path: 'webauth',
    component: WebauthPopupComponent,
    pathMatch: 'full',
  },
  {
    path: 'webauth-redirect',
    component: WebauthRedirectComponent,
    pathMatch: 'full',
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: '**',
    redirectTo: '/error',
  },
];

export const AppRoutingModule = RouterModule.forRoot(routes);
